import { z } from 'zod';
/**
 * Recherche transverse cloisonnée (ADR-0015). Un seul terme interroge toutes les entités
 * porteuses d'un libellé lisible ; le résultat est un flux de « hits » typés que le front
 * regroupe par nature. Contrat volontairement minimal : le moteur interne (aujourd'hui
 * `contains` Prisma) peut évoluer sans toucher à cette forme.
 */
/** Nombre de résultats par type, borné pour rester une recherche instantanée (pas une page). */
export const SEARCH_LIMIT_DEFAULT = 5;
export const SEARCH_LIMIT_MAX = 20;
/** Longueur maximale du terme : au-delà, ce n'est plus une recherche mais un abus. */
export const SEARCH_TERM_MAX = 120;
export const searchQuerySchema = z.object({
    // `.trim()` avant `.min(1)` : une requête d'espaces seuls est vide, pas une recherche.
    q: z.string().trim().min(1).max(SEARCH_TERM_MAX),
    limit: z.coerce.number().int().min(1).max(SEARCH_LIMIT_MAX).default(SEARCH_LIMIT_DEFAULT),
});
/**
 * Natures d'entités indexées. `fieldSession` = session de vol côté produit. `model` est le registre
 * cloisonné de l'organisation ; `libraryModel` est la bibliothèque de modèles pré-entraînés
 * (curation **globale**, ADR-0018), distincte car non cloisonnée et pointant vers la section
 * « Bibliothèque » plutôt que vers un modèle de l'organisation.
 */
export const SEARCH_ENTITY_TYPES = [
    'campaign',
    'fieldSession',
    'video',
    'model',
    'libraryModel',
];
//# sourceMappingURL=search.js.map